import { type Set, Map as ImmutableMap } from 'immutable';
import has from 'lodash/has';
import isPlainObject from 'lodash/isPlainObject';
import mapValues from 'lodash/mapValues';
import merge from 'lodash/merge';

import { type IListOf, type IMapOf } from '../types';

export const Map = <Obj extends Record<PropertyKey, unknown> = Record<PropertyKey, unknown>>(
  obj?: Obj,
): IMapOf<Obj> => ImmutableMap(obj ?? {}) as IMapOf<Obj>;

export function addListToSet(list: IListOf<unknown>, set: Set<unknown>): Set<unknown> {
  return set.withMutations((mutable: Set<unknown>) => {
    list.forEach((value: unknown) => {
      mutable.add(value);
    });
  });
}

export function toJS(value: $TSFixMe): $TSFixMe {
  return 'toJS' in value ? value?.toJS?.() : value;
}

export function mergeDeepRecursive(map: IMapOf<$TSFixMe>, input = {}): IMapOf<$TSFixMe> {
  const source = toJS(input);

  const output = mapValues(source, (value, key) => {
    return isPlainObject(value) ? merge(map.get(key, {}), value) : value;
  });

  map
    .keySeq()
    .toArray()
    .forEach((key: $TSFixMe) => {
      output[key] = !has(output, key) ? map.get(key) : output[key];
    });
  return map.mergeDeep(output);
}
